function busRaf() {
  gsap.ticker.add(onRafBis)
  window.deltaRatio = gsap.ticker.deltaRatio()
  if (isNaN(window.deltaRatio)) window.deltaRatio = 1

  let scrollPosOld = 0
  window.scrollSpeed = 0

  function onRafBis(timer) {
    window.deltaRatio = gsap.ticker.deltaRatio()
    if (isNaN(window.deltaRatio)) window.deltaRatio = 1

    window.scrollSpeed = Math.round((st.eased - scrollPosOld) / window.deltaRatio * 100) / 100
    scrollPosOld = st.eased

    bus.emit('raf', timer)
  }
}

export default busRaf


/*
  bus.on('raf', someStuff)
  bus.off('raf', someStuff)// kill
*/